<template>
  <section class="suggestions-section" data-testid="suggestions-section">
    <Heading :level="2" class="suggestions-section__title">
      Sugestões do especialista
    </Heading>
    <FilterSelect
      v-model="selectedFilter"
      class="suggestions-section__filter"
      label="Todos"
      :disabled="isDisabled"
      :options="filterOptions"
      use-option-label
      @change="handleChangeFilter"
    />
    <div class="suggestions-section__content">
      <HelperViewContextual
        v-if="isEmpty"
        class="suggestions-section__helper-view"
        icon="ED0030"
        :description="emptyTexts.description"
        :button-label="emptyTexts.buttonLabel"
        @click="goHome"
      />
      <div v-else>
        <SuggestionCard
          v-for="(suggestion, index) in filteredSuggestions"
          :key="index"
          :suggestion="suggestion"
          @suggestion-click="emitSuggestionClick"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  Heading,
  FilterSelect,
  HelperViewContextual
} from '@warrenbrasil/nebraska-web';
import { SuggestionCard } from './components/SuggestionCard';
import { IInvestmentSuggestion } from '@/modules/wealth/services/investment-suggestions';

@Component({
  components: {
    Heading,
    FilterSelect,
    HelperViewContextual,
    SuggestionCard
  }
})
export default class SuggestionsSection extends Vue {
  @Prop({ type: Array, required: true })
  private suggestions!: IInvestmentSuggestion[];

  @Emit('suggestion-click')
  emitSuggestionClick() {}

  filteredSuggestions: IInvestmentSuggestion[] = [];
  selectedFilter = '';
  filterOptions = [
    {
      label: 'Todos',
      value: ''
    },
    {
      label: 'Investimento',
      value: 'Investment'
    },
    {
      label: 'Resgate',
      value: 'Redemption'
    }
  ];

  get isDisabled() {
    return this.suggestions.length === 0;
  }

  get isEmpty() {
    return this.filteredSuggestions.length === 0;
  }

  get emptyTexts() {
    switch (this.selectedFilter) {
      case 'Investment':
        return {
          description: 'Não existem sugestões de investimento pendentes'
        };
      case 'Redemption':
        return {
          description: 'Não existem sugestões de resgate pendentes'
        };
      default:
        return {
          description: 'Não existem sugestões pendentes',
          buttonLabel: 'Voltar para a home'
        };
    }
  }

  handleChangeFilter() {
    this.filteredSuggestions = this.suggestions;

    if (this.selectedFilter !== '') {
      this.filteredSuggestions = this.filteredSuggestions.filter(item => {
        return item.type.value === this.selectedFilter;
      });
    }
  }

  goHome() {
    this.$router.push({ name: 'home' });
  }

  mounted() {
    this.filteredSuggestions = this.suggestions;
  }
}
</script>

<style lang="less" scoped>
.suggestions-section {
  &__title {
    margin-bottom: @size-spacing-x700;
  }

  &__filter {
    margin-bottom: @size-spacing-x500;
  }

  &__content {
    max-width: 592px;
  }

  &__helper-view {
    max-width: 320px;
    margin: @size-spacing-x1400 auto;
  }
}
</style>
